"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRollerBrushFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5 2a2 2 0 00-2 2v3a2 2 0 002 2h11a2 2 0 002-2 1 1 0 011 1v1.85a1 1 0 01-1 1h-5a3 3 0 00-3 3V15H9v5a2 2 0 104 0v-5h-1v-1.15a1 1 0 011-1h5a3 3 0 003-3V8a3 3 0 00-3-3V4a2 2 0 00-2-2H5z' }))); };
exports.default = SvgRollerBrushFilled;
//# sourceMappingURL=RollerBrushFilled.js.map